import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["svg", "src", "alt", "useNextImage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Image as ChakraImage } from '@chakra-ui/react';
import Image from 'next/image';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Icon(_ref) {
  var _otherProps$height, _otherProps$width;
  var svg = _ref.svg,
    src = _ref.src,
    alt = _ref.alt,
    useNextImage = _ref.useNextImage,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var height = (_otherProps$height = otherProps.height) !== null && _otherProps$height !== void 0 ? _otherProps$height : '4rem';
  var width = (_otherProps$width = otherProps.width) !== null && _otherProps$width !== void 0 ? _otherProps$width : '10.75rem';
  if (src && useNextImage) {
    return _jsx(Box, _objectSpread(_objectSpread({
      position: "relative"
    }, otherProps), {}, {
      height: height,
      width: width,
      "data-testid": "svg-container",
      children: _jsx(Image, {
        src: src,
        alt: alt !== null && alt !== void 0 ? alt : '',
        fill: true,
        style: {
          objectFit: 'contain'
        },
        sizes: '172px'
      })
    }));
  }
  if (src) {
    return _jsx(ChakraImage, _objectSpread(_objectSpread(_objectSpread({
      src: src
    }, alt !== undefined ? {
      alt
    } : {}), otherProps), {}, {
      "data-testid": "svg-container"
    }));
  }
  return _jsx(Box, _objectSpread(_objectSpread({}, otherProps), {}, {
    "data-testid": "svg-container",
    children: svg
  }));
}